import { UseFormReturn } from 'react-hook-form'

import { CustomFormQuestion } from 'components/tools/CustomForm/types'

type Params = {
  formMethods: UseFormReturn<any>
  questions: CustomFormQuestion[]
}

export default function setAtualizacaoDeDadosCadastraisSEDE(params: Params): CustomFormQuestion[] {
  const { formMethods, questions } = params

  const { watch } = formMethods

  const tagForQuestion = Object.fromEntries(questions.flatMap((q) => q.tags.map((tag: string) => [tag, q.slug])))

  const possui_deficiencia = watch(`form_answers.${tagForQuestion['possui_deficiencia']}`)

  const filteredQuestions = questions.filter((question) => {
    //Hepatite B
    if (question.tags.includes('tipo_deficiencia') || question.tags.includes('laudo_deficiencia')) {
      if (possui_deficiencia === 'Sim') {
        return true
      } else {
        return false
      }
    }

    return true
  })

  return filteredQuestions
}
